export const TEXTS = {
  MODAL_INFO_TITLE: 'Привязано колонок',
  MODAL_DESCRIPTION: 'Колонки объединены в мультирум и играют одну волну.',
  MODAL_CLOSE_BUTTON_TEXT: 'Понятно',
  SBERBOOM: 'SberBoom',
};
